import { useEffect } from 'react'

import Form from './Form'

import { useReviewForm } from './useReviewForm'

const ReviewForm = () => {
  const { rating, setRating, hasError, showSuccess, submitReview } = useReviewForm()

  const onChangeRating = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value)

    setRating(value)
  }

  useEffect(() => {
    if (rating) submitReview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rating])

  return (
    <Form
      showError={hasError}
      showSuccess={showSuccess}
      onChangeRating={onChangeRating}
      rating={rating}
    />
  )
}

export default ReviewForm
